import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    state: {
        show: true,
        title:  i18n.t('message.country'),
        sortable: true,
        column: 'state'
    },
    region: {
        show: true,
        title:  i18n.t('message.region'),
        sortable: true,
        column: 'region'
    },
    city: {
        show: true,
        title:  i18n.t('message.city'),
        sortable: true,
        column: 'city'
    },
    count: {
        show: true,
        title:  i18n.t('message.quantity'),
        sortable: true,
        column: 'count'
    },
    total_price: {
        show: true,
        title:  i18n.t('message.total_price'),
        sortable: true,
        column: 'total_price'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
